define([
    './2D/IconSymbol',
    './2D/MultipleCircles',
    './2D/Plotting',
    './2D/PolygonSymbol',
    './2D/PolylineSymbol',
    './2D/TextSymbol',
    './2D/VectorGraphSymbol',
    './3D/DistanceMeasure',
    './3D/GeoCuboid',
    './3D/GeoFence',
    './3D/GeoSphere',
    './3D/Label',
    './3D/Model',
    './3D/Polygon',
    './3D/Ripple',
    './3D/VideoFusion',
    './AI/Path',
    './AI/Presentation',
    './AI/PresentationItem',
    './Analysis/SightLineAnalysis',
    './Analysis/ViewShedAnalysis',
    './Enum/EnumAlignmentMode',
    './Enum/EnumAltitudeMode',
    './Enum/EnumBackdropMode',
    './Enum/EnumColorMode',
    './Enum/EnumConditionType',
    './Enum/EnumEditMode',
    './Enum/EnumGeoFenceEditMode',
    './Enum/EnumMeasureUnit',
    './Enum/EnumObservationMode',
    './Enum/EnumPathEditMode',
    './Enum/EnumPathPlayMode',
    './Enum/EnumPathPlayStatus',
    './Enum/EnumPlottingStatus',
    './Enum/EnumPlottingType',
    './Enum/EnumPolygonEditMode',
    './Enum/EnumPolygonEffectMode',
    './Enum/EnumPresentationItemType',
    './Enum/EnumPresentationStatus',
    './Enum/EnumRenderMode',
    './Enum/EnumRippleEditMode',
    './Enum/EnumRippleModulationMode',
    './Enum/EnumRotateMode',
    './Enum/EnumTimeIntervalType',
    './Enum/EnumVideoPlayMode',
    './Enum/EnumVideoPlayStatus',
    './Enum/EnumZoomMode',
    './Environment/Atmosphere',
    './Environment/GlobalFog',
    './Environment/GlobalShadow',
    './Layer/ElevationLayer',
    './Layer/FeatureLayer',
    './Layer/ImageLayer',
    './Layer/MeshLayer',
    './Layer/ModelLayer',
    './System/Camera',
    './System/CircleObj',
    './System/ColorObj',
    './System/Conversion',
    './System/Map',
    './System/Monitor',
    './System/OGCConnector',
    './System/Picker',
    './System/ServerConnector',
    './System/Time',
    './System/Vec2Obj',
    './System/Vec3Obj',
    './System/WayPoint',
    './System/WMSConnector',
    './System/WMSInformation',
    './System/WMTSConnector',
    './System/WMTSInformation',
    './Util/defaultValue',
    './Util/defined',
    './Util/defineProperties',
    './Util/freezeObject'
], function (
    IconSymbol,
    MultipleCircles,
    Plotting,
    PolygonSymbol,
    PolylineSymbol,
    TextSymbol,
    VectorGraphSymbol,
    DistanceMeasure,
    GeoCuboid,
    GeoFence,
    GeoSphere,
    Label,
    Model,
    Polygon,
    Ripple,
    VideoFusion,
    Path,
    Presentation,
    PresentationItem,
    SightLineAnalysis,
    ViewShedAnalysis,
    EnumAlignmentMode,
    EnumAltitudeMode,
    EnumBackdropMode,
    EnumColorMode,
    EnumConditionType,
    EnumEditMode,
    EnumGeoFenceEditMode,
    EnumMeasureUnit,
    EnumObservationMode,
    EnumPathEditMode,
    EnumPathPlayMode,
    EnumPathPlayStatus,
    EnumPlottingStatus,
    EnumPlottingType,
    EnumPolygonEditMode,
    EnumPolygonEffectMode,
    EnumPresentationItemType,
    EnumPresentationStatus,
    EnumRenderMode,
    EnumRippleEditMode,
    EnumRippleModulationMode,
    EnumRotateMode,
    EnumTimeIntervalType,
    EnumVideoPlayMode,
    EnumVideoPlayStatus,
    EnumZoomMode,
    Atmosphere,
    GlobalFog,
    GlobalShadow,
    ElevationLayer,
    FeatureLayer,
    ImageLayer,
    MeshLayer,
    ModelLayer,
    Camera,
    CircleObj,
    ColorObj,
    Conversion,
    Map,
    Monitor,
    OGCConnector,
    Picker,
    ServerConnector,
    Time,
    Vec2Obj,
    Vec3Obj,
    WayPoint,
    WMSConnector,
    WMSInformation,
    WMTSConnector,
    WMTSInformation,
    defaultValue,
    defined,
    defineProperties,
    freezeObject
) {
    'use strict';

    /**
     * CooWasm是三维地图模块管理包。
     * @alias CooWasm
     */
    function CooWasm() {
        this._version = "7.0.0-alpha";
    };
    defineProperties(CooWasm.prototype, {
        /**
         * 获取CooWasm版本号。
         * @memberof CooWasm.prototype
         * @type {String}
         * @readonly
         */
        version: {
            get: function () {
                return this._version;
            }
        }
    });
    CooWasm['IconSymbol'] = IconSymbol;
    CooWasm['MultipleCircles'] = MultipleCircles;
    CooWasm['Plotting'] = Plotting;
    CooWasm['PolygonSymbol'] = PolygonSymbol;
    CooWasm['PolylineSymbol'] = PolylineSymbol;
    CooWasm['TextSymbol'] = TextSymbol;
    CooWasm['VectorGraphSymbol'] = VectorGraphSymbol;

    CooWasm['DistanceMeasure'] = DistanceMeasure;
    CooWasm['GeoCuboid'] = GeoCuboid;
    CooWasm['GeoFence'] = GeoFence;
    CooWasm['GeoSphere'] = GeoSphere;
    CooWasm['Label'] = Label;
    CooWasm['Model'] = Model;
    CooWasm['Polygon'] = Polygon;
    CooWasm['Ripple'] = Ripple;
    CooWasm['VideoFusion'] = VideoFusion;

    CooWasm['Path'] = Path;
    CooWasm['Presentation'] = Presentation;
    CooWasm['PresentationItem'] = PresentationItem;

    CooWasm['SightLineAnalysis'] = SightLineAnalysis;
    CooWasm['ViewShedAnalysis'] = ViewShedAnalysis;

    CooWasm['EnumAlignmentMode'] = EnumAlignmentMode;
    CooWasm['EnumAltitudeMode'] = EnumAltitudeMode;
    CooWasm['EnumBackdropMode'] = EnumBackdropMode;
    CooWasm['EnumColorMode'] = EnumColorMode;
    CooWasm['EnumConditionType'] = EnumConditionType;
    CooWasm['EnumEditMode'] = EnumEditMode;
    CooWasm['EnumGeoFenceEditMode'] = EnumGeoFenceEditMode;
    CooWasm['EnumMeasureUnit'] = EnumMeasureUnit;
    CooWasm['EnumObservationMode'] = EnumObservationMode;
    CooWasm['EnumPathEditMode'] = EnumPathEditMode;
    CooWasm['EnumPathPlayMode'] = EnumPathPlayMode;
    CooWasm['EnumPathPlayStatus'] = EnumPathPlayStatus;
    CooWasm['EnumPlottingStatus'] = EnumPlottingStatus;
    CooWasm['EnumPlottingType'] = EnumPlottingType;
    CooWasm['EnumPolygonEditMode'] = EnumPolygonEditMode;
    CooWasm['EnumPolygonEffectMode'] = EnumPolygonEffectMode;
    CooWasm['EnumPresentationItemType'] = EnumPresentationItemType;
    CooWasm['EnumPresentationStatus'] = EnumPresentationStatus;
    CooWasm['EnumRenderMode'] = EnumRenderMode;
    CooWasm['EnumRippleEditMode'] = EnumRippleEditMode;
    CooWasm['EnumRippleModulationMode'] = EnumRippleModulationMode;
    CooWasm['EnumRotateMode'] = EnumRotateMode;
    CooWasm['EnumTimeIntervalType'] = EnumTimeIntervalType;
    CooWasm['EnumVideoPlayMode'] = EnumVideoPlayMode;
    CooWasm['EnumVideoPlayStatus'] = EnumVideoPlayStatus;
    CooWasm['EnumZoomMode'] = EnumZoomMode;

    CooWasm['Atmosphere'] = Atmosphere;
    CooWasm['GlobalFog'] = GlobalFog;
    CooWasm['GlobalShadow'] = GlobalShadow;

    CooWasm['ElevationLayer'] = ElevationLayer;
    CooWasm['FeatureLayer'] = FeatureLayer;
    CooWasm['ImageLayer'] = ImageLayer;
    CooWasm['MeshLayer'] = MeshLayer;
    CooWasm['ModelLayer'] = ModelLayer;

    CooWasm['Camera'] = Camera;
    CooWasm['CircleObj'] = CircleObj;
    CooWasm['ColorObj'] = ColorObj;
    CooWasm['Conversion'] = Conversion;
    CooWasm['Map'] = Map;
    CooWasm['Monitor'] = Monitor;
    CooWasm['OGCConnector'] = OGCConnector;
    CooWasm['Picker'] = Picker;
    CooWasm['ServerConnector'] = ServerConnector;
    CooWasm['Time'] = Time;
    CooWasm['Vec2Obj'] = Vec2Obj;
    CooWasm['Vec3Obj'] = Vec3Obj;
    CooWasm['WayPoint'] = WayPoint;
    CooWasm['WMSConnector'] = WMSConnector;
    CooWasm['WMSInformation'] = WMSInformation;
    CooWasm['WMTSConnector'] = WMTSConnector;
    CooWasm['WMTSInformation'] = WMTSInformation;

    CooWasm['defaultValue'] = defaultValue;
    CooWasm['defined'] = defined;
    CooWasm['defineProperties'] = defineProperties;
    CooWasm['freezeObject'] = freezeObject;

    return CooWasm;
});